import React, { FC, useMemo } from 'react';
import { useDeepCompareMemo } from '@clatter/platform';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import styled from 'styled-components';

import { DataGridPremium, IconButton } from '@clatter/ui';
import { displayNameColumn, updatedAtColumn } from '../../../../../helpers/dataGrid';

import { NgButton } from '../../../../UI';

interface Props {
  isLoading?: boolean;
  items: WorkspaceQuery[];
  onAction: (action: NgAction<WorkspaceQuery | null>) => void;
}

const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`;

export const WorkspaceTemplateQueriesList: FC<Props> = ({ items, isLoading: isParentLoading, onAction }) => {
  const isLoading = isParentLoading;

  const rows = useDeepCompareMemo(() => (items || []).map((item) => ({ id: item?.ID, ...item })), [items]);

  const handleCreateClick = () => {
    onAction({ type: 'CREATE', payload: null });
  };

  const handleEditClick = (item: any) => {
    onAction({ type: 'EDIT', payload: item });
  };

  const handleDeleteClick = (item: any) => {
    if (window.confirm(`Delete "${item?.DisplayName}" template?`)) {
      onAction({ type: 'DELETE', payload: item });
    }
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      displayNameColumn,
      { ...updatedAtColumn, flex: 0.15, field: 'UpdatedAt', headerName: 'Last Updated' },
      {
        field: 'actions',
        headerName: 'Actions',
        flex: 0.1,
        sortable: false,
        disableExport: true,
        renderCell: (params) => (
          <>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/*//@ts-ignore*/}
            <IconButton data-id={params?.id} onClick={() => handleEditClick(params.row)} tooltip="Edit" testId="ItemEditButton">
              <EditOutlinedIcon />
            </IconButton>

            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/*//@ts-ignore*/}
            <IconButton data-id={params?.id} onClick={() => handleDeleteClick(params.row)} tooltip="Delete" testId="ItemDeleteButton">
              <DeleteOutlinedIcon />
            </IconButton>
          </>
        ),
      },
    ];
  }, [handleEditClick, handleDeleteClick]);

  return (
    <StyledContainer>
      <StyledHeader>
        <NgButton onClick={handleCreateClick}>Add New Query</NgButton>
      </StyledHeader>

      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*//@ts-ignore*/}
      <DataGridPremium
        name="workspace-templates-queries-list"
        rows={rows}
        loading={isLoading}
        columns={columns}
        dataGridProps={{
          onRowDoubleClick: (params: GridRowParams) => {
            handleEditClick(params.row);
          },
        }}
        disablePersist
      />
    </StyledContainer>
  );
};
